import * as types from '../services/ContentManagementActionType';
import { getDropdownOptions } from '../../../utils/dropdownUtils';

export default function CommunicationCenterReducer(state = {}, action) {
  switch (action.type) {
    case types.GET_ALL_COMMUNICATIONS_REQUEST:
      return {
        ...state,
        isCommunicationCenterLoading: true
      };
    case types.GET_ALL_COMMUNICATIONS_SUCCESS:
      return {
        ...state,
        isCommunicationCenterLoading: false,
        communicationsDataList: action.payload?.communicationsDataList || [],
        totalRecords: action.payload?.totalRecords || 0,
      };
    case types.GET_ALL_COMMUNICATIONS_FAILURE:
      return {
        ...state,
        isCommunicationCenterLoading: false
      };
    case types.ENABLE_DISABLE_COMMUNICATIONS_REQUEST:
      return {
        ...state,
        isCommunicationCenterLoading: true
      };
    case types.ENABLE_DISABLE_COMMUNICATIONS_SUCCESS:
      return {
        ...state,
        isCommunicationCenterLoading: false,
      };
    case types.ENABLE_DISABLE_COMMUNICATIONS_FAILURE:
      return {
        ...state,
        isCommunicationCenterLoading: false
      };
    case types.GET_COMMUNICATIONS_DOCUMENT_TYPE_DROPDOWN_REQUEST:
      return {
        ...state,
        isCommunicationCenterLoading: true
      };
    case types.GET_COMMUNICATIONS_DOCUMENT_TYPE_DROPDOWN_SUCCESS:
      return {
        ...state,
        isCommunicationCenterLoading: false,
        documentTypeDropdown: getDropdownOptions( action.payload?.data?.items) || [],
      };
    case types.GET_COMMUNICATIONS_DOCUMENT_TYPE_DROPDOWN_FAILURE:
      return {
        ...state,
        isCommunicationCenterLoading: false
      };
    default:
      return state;
  }
}
